import type { ClientConfig, ClientTheme } from '../../model/clientConfig.types'
import { layoutConfig } from './layout'
import clientLogo from './logo.coles.svg'
import { clientTheme } from './theme'

/**
 * Coles-specific theme configuration
 * Extends the base ClientTheme with any Coles-specific theme properties
 */
interface ColesTheme extends ClientTheme {
  // Add any Coles-specific theme properties here
  brandColor: string
}

/**
 * Coles-specific configuration
 * Extends the base ClientConfig with Coles-specific properties
 */
interface ColesConfig extends Omit<ClientConfig, 'theme'> {
  theme: ColesTheme
}

/**
 * Coles client configuration
 * This is the main configuration object for the Coles client
 */
export const colesConfig: ColesConfig = {
  name: 'Coles',
  theme: clientTheme,
  logo: clientLogo,
  layout: layoutConfig,
  service: {
    groupField: 'orderGroupId',
    acceptedGroupOrderTypes: ['Partner Delivery', 'Rapid Delivery', 'Early Rapid Delivery', 'Early Partner Delivery'],
  },
  regionAlias: {
    au: 'XTW7ZVC8TU1W',
  },
}
